module.exports = __webpack_public_path__ + "img/no_results.6a0b391d.svg";